"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitLocationFeedback = exports.trackLocationClick = exports.trackPageView = exports.clearFilters = exports.shareLocation = exports.contactLocation = exports.claimLocation = exports.loadLocation = exports.initialSearch = exports.updateSpecialtyFilter = exports.updateMedicationFilter = exports.updateFilter = exports.searchByQuery = exports.searchLocations = void 0;

var _types = require("./types");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var DEFAULT_COORDS = {
  lat: 30.267269,
  lng: -97.743147
};
/**
 * Query locations in Firestore by lat, lng, and radius
 */

var searchLocations = function searchLocations(query, lat, lng, radiusInMiles, filter, enqueueSnackbar) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var api, tracker, _getState$login, remainingSearches, blockCountry, isBlacklisted, userIP, searchId;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref.api, tracker = _ref.tracker;
              _getState$login = getState().login, remainingSearches = _getState$login.remainingSearches, blockCountry = _getState$login.blockCountry, isBlacklisted = _getState$login.isBlacklisted, userIP = _getState$login.userIP;

              if (!(userIP && !blockCountry && !isBlacklisted && remainingSearches > 0)) {
                _context.next = 11;
                break;
              }

              dispatch({
                type: _types.LOCATIONS_LOADING,
                payload: {
                  lat: lat,
                  lng: lng,
                  radius: radiusInMiles
                }
              });
              tracker.trackSearch(query, lat, lng, radiusInMiles, filter, getState().login.userIP); // KBM - Log the search and any medication or specialty filters to the db for reporting

              _context.next = 7;
              return api.logSearch(query, radiusInMiles, lat, lng, getState().login.userIP);

            case 7:
              searchId = _context.sent;

              if (filter.medicationsAvailable && filter.medicationsAvailable.length) {
                api.logMedicationFilter(searchId, filter.medicationsAvailable);
              }

              if (filter.specialty && filter.specialty.length) {
                api.logSpecialtyFilter(searchId, filter.specialty);
              }

              return _context.abrupt("return", api.searchLocations(lat, lng, radiusInMiles, document.domain).then(function (locations) {
                dispatch({
                  type: _types.LOCATIONS_SUCCESS,
                  payload: {
                    locations: locations,
                    searchId: searchId
                  }
                }); // console.log("searchLocations", locations);

                // console.log("searchLocations", locations);
                if (remainingSearches === 1) {
                  return api.logRateLimitExceeded(getState().login.userIP, document.domain);
                }
              }).catch(function (error) {
                console.error(error);
                dispatch({
                  type: _types.LOCATIONS_ERROR,
                  error: error
                });
              }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Query locations in Firestore by lat, lng, and radius
 */


exports.searchLocations = searchLocations;

var searchByQuery = function searchByQuery(query, radiusInMiles, filter, enqueueSnackbar) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref3) {
      var api, tracker, _getState$login2, remainingSearches, blockCountry, isBlacklisted, userIP, point;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref3.api, tracker = _ref3.tracker;
              _getState$login2 = getState().login, remainingSearches = _getState$login2.remainingSearches, blockCountry = _getState$login2.blockCountry, isBlacklisted = _getState$login2.isBlacklisted, userIP = _getState$login2.userIP;

              if (!(userIP && !blockCountry && !isBlacklisted && remainingSearches > 0)) {
                _context2.next = 8;
                break;
              }

              dispatch({
                type: _types.LOCATIONS_GEOCODING,
                payload: query
              });
              _context2.next = 6;
              return api.geocodeAddress(query);

            case 6:
              point = _context2.sent;

              if (point) {
                dispatch(searchLocations(query, point.lat, point.lng, radiusInMiles, filter, enqueueSnackbar));
              } else {
                console.error("No Location Found");
                enqueueSnackbar("No Location Found", {
                  variant: 'error',
                  autoHideDuration: 3000
                });
                dispatch({
                  type: _types.LOCATIONS_ERROR,
                  error: "No locations found"
                });
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.searchByQuery = searchByQuery;

var updateFilter = function updateFilter(filterKey, value) {
  return function (dispatch, getState, _ref5) {
    var tracker = _ref5.tracker;
    tracker.trackFilter(filterKey, value);
    return dispatch({
      type: _types.LOCATIONS_UPDATE_FILTER,
      payload: {
        filterKey: filterKey,
        value: value
      }
    });
  };
};

exports.updateFilter = updateFilter;

var updateMedicationFilter = function updateMedicationFilter(value, lastSearchId) {
  return function (dispatch, getState, _ref6) {
    var api = _ref6.api;
    lastSearchId = getState().locations.lastSearchId;
    api.logMedicationFilter(lastSearchId, value);
    return dispatch(updateFilter("medicationsAvailable", value, lastSearchId));
  };
};

exports.updateMedicationFilter = updateMedicationFilter;

var updateSpecialtyFilter = function updateSpecialtyFilter(value, lastSearchId) {
  return function (dispatch, getState, _ref7) {
    var api = _ref7.api;
    api.logSpecialtyFilter(lastSearchId, value);
    return dispatch(updateFilter("specialty", value, lastSearchId));
  };
};

exports.updateSpecialtyFilter = updateSpecialtyFilter;

var initialSearch = function initialSearch(query, searchRadius, filter) {
  return function (dispatch, getState, _ref8) {
    var api = _ref8.api;
    return new Promise(function (resolve, reject) {
      try {
        navigator.geolocation.getCurrentPosition(function (result) {
          //TODO: This
          // Tracker.trackEvent(CATEGORY, "current position succeeded", "", "");
          if (result.coords && result.coords.latitude && result.coords.longitude) {//TODO: This
            // api.trackSearchQuery("initial", searchRadius, result.coords.latitude, result.coords.longitude, filter);
          }

          resolve(dispatch(searchLocations(query, result.coords.latitude, result.coords.longitude, searchRadius, filter)));
        }, function (err) {
          //TODO: This
          // Tracker.trackEvent(CATEGORY, "current position failed", "", "");
          console.warn("ERROR(".concat(err.code, "): ").concat(err.message));
          resolve(dispatch(searchLocations(query, DEFAULT_COORDS.lat, DEFAULT_COORDS.lng, searchRadius, filter)));
        }, {
          maximumAge: 75000,
          enableHighAccuracy: false,
          timeout: 10000
        });
      } catch (err) {
        reject(err);
      }
    });
  };
};

exports.initialSearch = initialSearch;

var loadLocation = function loadLocation(locationId, setLoading, goBack) {
  return function (dispatch, getState, _ref9) {
    var api = _ref9.api;
    dispatch({
      type: _types.LOCATION_LOADING
    });
    return api.getSearchableLocation(locationId).then(function (location) {
      setLoading(false);
      return dispatch({
        type: _types.LOCATION_SUCCESS,
        payload: location
      });
    }).catch(function (error) {
      console.error(error);
      dispatch({
        type: _types.LOCATION_ERROR
      });
      goBack();
    });
  };
};

exports.loadLocation = loadLocation;

var claimLocation = function claimLocation(user, locationId, locationName) {
  return function (dispatch, getState, _ref10) {
    var api = _ref10.api;
    api.claimLocation(user.email, user.email, user.orgIds, locationId, locationName);
    return dispatch({
      type: _types.LOCATIONS_UPDATE_ORGID,
      payload: locationId
    });
  };
};

exports.claimLocation = claimLocation;

var contactLocation = function contactLocation(name, email, phone, subject, message, locationId) {
  return function (dispatch, getState, _ref11) {
    var api = _ref11.api;
    return api.createLocationContactRequest(name, email, phone, subject, message, locationId);
  };
};

exports.contactLocation = contactLocation;

var shareLocation = function shareLocation(fromName, toName, toEmail, message, locationId) {
  return function (dispatch, getState, _ref12) {
    var api = _ref12.api;
    return api.shareLocation(fromName, toName, toEmail, message, locationId);
  };
};

exports.shareLocation = shareLocation;

var clearFilters = function clearFilters() {
  return {
    type: _types.LOCATIONS_CLEAR_FILTERS
  };
};

exports.clearFilters = clearFilters;

var trackPageView = function trackPageView(locationId) {
  return function (dispatch, getState, _ref13) {
    var api = _ref13.api;
    var pageViewId = api.logLocationDetailView(locationId);
    return dispatch({
      type: _types.LOCATION_PAGE_VIEW,
      payload: pageViewId
    });
  };
};

exports.trackPageView = trackPageView;

var trackLocationClick = function trackLocationClick(locationId, eventName, lastPageViewId) {
  return function (dispatch, getState, _ref14) {
    var api = _ref14.api;
    return api.logLocationClick(locationId, eventName, lastPageViewId);
  };
};

exports.trackLocationClick = trackLocationClick;

var submitLocationFeedback = function submitLocationFeedback(locationId, locationName, feedback, email, enqueueSnackbar) {
  return function (dispatch, getState, _ref15) {
    var api = _ref15.api;
    return api.submitLocationFeedback(locationId, locationName, feedback, email).then(function () {
      enqueueSnackbar("Your feedback has been recorded!", {
        variant: "success"
      });
    }).catch(function (err) {
      enqueueSnackbar(err.message, {
        variant: "error"
      });
    });
  };
};

exports.submitLocationFeedback = submitLocationFeedback;